// WishlistContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
    const [wishlist, setWishlist] = useState([]);

    useEffect(() => {
        const savedWishlist = localStorage.getItem("wishlist");
        if (savedWishlist) {
            setWishlist(JSON.parse(savedWishlist));
        }
    }, []);

    useEffect(() => {
        if (wishlist.length > 0) {
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
        } else {
            localStorage.removeItem("wishlist");
        }
    }, [wishlist]);

    const toggleWishlistItem = (item) => {
        const exists = wishlist.some(w => w.room_name === item.room_name);
        const updated = exists
            ? wishlist.filter(w => w.room_name !== item.room_name)
            : [...wishlist, item];
        setWishlist(updated);
    };

    const handleRemoveFromWishlist = (roomName) => {
        const updated = wishlist.filter(w => w.room_name !== roomName);
        setWishlist(updated);
    };

    return (
        <WishlistContext.Provider value={{ wishlist, toggleWishlistItem, handleRemoveFromWishlist }}>
            {children}
        </WishlistContext.Provider>
    );
};

export const useWishlist = () => useContext(WishlistContext);
